module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-3@2x__ce00c72cfd245f769a2cda581c0d5ff0.png";